module.exports = __webpack_public_path__ + "static/media/startup-branco.bdf52532.svg";